export const strings = {
  microsite_invitations: 'Mikrosite Davetiyeleri',
  received: 'Kabul edilmiş',
  requested_to_join: 'Katılmanız istendi',
  discover_microsites: 'Mikrositeleri keşfedin',
  my_microsites: 'Mikrositelerim',
  accept: 'Kabul etmek',
  reject: 'Reddetmek',
  request_to_join: 'Katılma isteği',
  search_microsites: 'Mikrositelerde arama yapın',
  load_more: 'Daha Fazlasını Yükle',
  see_all: 'Tümünü Gör',
  withdraw: 'Geri çekilmek',
  no_microsite: 'Mikro site mevcut değil',
  members: 'üyeler',
  member: 'üye',
  title: 'Mikrosite',
  association_overview: 'Dernek Genel Bakışı',
  save: 'Kaydetmek',
  url: 'URL',
  view_360: '360 Derece Görünüm',
  redirection_url: "Yönlendirme URL'si",
  copy_redirection_url: "Yönlendirme URL'sini kopyala",
  update: 'Güncelleme',
  microsite_logo: 'Mikrosite Logosu',
  cover_image: 'Kapak Resmi',
  microsite_cover: 'Mikrosite Kapağı',
  upload_logo: 'Logoyu Yükle',
  upload_cover: 'Kapak Yükle',
  edit_microsite_details: 'Mikrosite Ayrıntılarını Düzenle',
  survey_name: 'Anket Adı',
  survey_name_placeholder: 'Ankete Katılın',
  award_currency: 'Ödül Para Birimi',
  award_amount: 'Ödül Miktarı',
  award_amount_placeholder: 'Tutarı girin (sayı olarak)',
  start_time: 'Başlangıç Zamanı',
  start_time_placeholder: 'Başlangıç tarihi ve saati',
  expire_time: 'Son Kullanma Tarihi',
  expire_time_placeholder: 'Son kullanma tarihi ve saati',
  about_survey: 'Anket Hakkında',
  about_survey_placeholder: 'Buraya yaz...',
  upload_questionaire: 'Anketleri Yükle',
  upload_questionaire_placeholder: 'Yalnızca PDF, Doc, Docx, xls veya xlsx',
  attach_file: 'yüklendi',
  send_request: 'İstek Gönder',
  association_details: 'Dernek Detayları',
  home: 'Ev',
  news: 'Haberler',
  groups: 'Gruplar',
  webinars: 'Web seminerleri',
  events: 'Olaylar',
  articles: 'Makaleler',
  analytics: 'Analitik',
  admin: 'Yönetici',
  surveys: 'Anketler',
  about: 'Hakkında',
  eLearning: 'eÖğrenme',
  see_all_requested_to_join: 'Katılmak için istenen tüm kişileri görün',
  surveys_title: 'Anketler',
  survey_title: 'Anket',
  request_survey: 'Anket İsteği',
  rewards: 'Ödüller',
  expires_on: 'Sona erme tarihi',
  start: 'Başlangıç',
  resume: 'Sürdürmek',
  new_survey: 'Yeni Anket',
  edit_survey: 'Anketi Düzenle',
  edit: 'Düzenlemek',
  reward: 'Ödül',
  mutual_connections: 'Karşılıklı bağlantılar',
  no_mutual_connections: 'Karşılıklı Bağlantı Yok',
  microsite_name: 'Mikrosite Adı',
  microsite_name_placeholder: 'Mikrosite Adını Girin...',
  speciality: 'Uzmanlık',
  country: 'Ülke',
  brief: 'Kısa bilgi',
  microsite_brief_placeholder: 'Mikrosite hakkında kısa bilgi girin...',
  founded_in: 'Kurulduğu Yıl',
  industry: 'Sanayi',
  website_link: 'Web Sitesi Bağlantısı',
  contact_no: 'İletişim No',
  contact_no_placeholder: 'İletişim numaranızı girin...',
  email: 'E-posta',
  email_placeholder: 'E-posta giriniz...',
  address: 'Adres',
  address_placeholder: 'Adres giriniz...',
  about_microsite: 'Mikrosite Hakkında',
  create_microsite: 'Mikrosite Oluştur',
  no_microsite_data: 'Mikro site yok',
  manage: 'Üstesinden gelmek',
  errors: {
    cover_required: 'Kapak gereklidir',
    cover_uploading: 'Kapak yükleniyor',
    video_required: 'Video gerekli',
    title_required: 'Başlık gerekli',
    title_max_length: 'Başlık maksimum uzunluğu 250 karakterdir',
    brief_required: 'Kısa açıklama gereklidir',
    brief_min_length: 'Kısa açıklama minimum uzunluğu 3 karakterdir',
    brief_max_length: 'Kısa açıklama maksimum uzunluğu 250 karakterdir',
    speciality_id_required: 'Uzmanlık Kimliği gereklidir',
    avatar_required: 'Avatar gerekli',
    country_id_required: 'Ülke Kimliği gereklidir',
    founded_in_required: 'Kuruluş tarihi gereklidir',
    category_id_required: 'Kategori Kimliği gereklidir',
    industry_id_required: 'Endüstri Kimliği gereklidir',
    contact_no_required: 'İletişim numarası gereklidir',
    email_required: 'E-posta gereklidir',
    email_validation: 'Geçerli bir e-posta olmalı',
    email_limit: 'E-posta uzunluğu 300 karakteri geçmemelidir',
    description_required: 'Açıklama gereklidir',
    description_min_length: 'Açıklamanın minimum uzunluğu 3 karakterdir',
    address_required: 'Adres gerekli',
    website_required: 'Web sitesi gereklidir',
    source_url: 'Geçerli bir web sitesi olmalı',
    source_max_limit: 'Web sitesinin uzunluğu 300 karakteri geçmemelidir',
    name_required: 'İsim gerekli',
    currency_required: 'Lütfen ödül para birimini seçin',
    amount_required: 'Lütfen ödül tutarını giriniz',
    amount_validation: 'Lütfen geçerli ödül tutarını girin',
    start_at_required: 'Lütfen start_at girin',
    expire_at_required: 'Lütfen expire_at girin',
    expire_at_validation: 'Bitiş tarihi başlangıç tarihinden büyük olmalıdır.',
    quest_required: 'Lütfen anketleri yükleyin',
  },
  leave_microsite: 'Mikrositeden ayrıl',
  leave_microsite_title: 'Mikrositeden ayrılmak istediğinizden emin misiniz?',
  leave_microsite_subtitle:
    'Mikrositeden ayrılmak istediğinizden emin misiniz?',
  view_members: 'Üyeleri görüntüle',
  wait: 'Lütfen bekleyin....',
  cancel: 'İptal etmek',
  edit_tab: 'Mikrosite Sekmesini Düzenle',
  delete_tab: 'Mikrosite Sekmesini Sil',
  delete_tab_text: 'Bu sekmeyi silmek istediğinizden emin misiniz?',
  update_tab: 'Mikrosite Sekmesini Güncelle',
  disabled_content: 'Engelli İçerik...',
  enabled_content: 'İçerik Etkinleştirildi...',
  manage_microsite: 'Mikrositeyi Yönet',
  how_to_use: 'Nasıl kullanılır',
  enable_content: 'İçeriği Etkinleştir',
  enable_content_text:
    'Bir içerik öğesini etkinleştirmek için bir öğeyi "Devre Dışı İçerik" kutusundan "Etkin İçerik" kutusuna taşımak üzere {drag_icon} simgesini tıklayın ve sürükleyin',
  rearrange_content: 'İçerik Sırasını Yeniden Düzenle',
  rearrange_content_text:
    'Sırayı yeniden düzenlemek için bir öğeyi başka bir öğenin üstüne/altına taşımak üzere tıklayın ve sürükleyin {drag_icon}',
  edit_content: 'İçeriği Düzenle',
  edit_content_text:
    'İçeriği düzenlemek/kaldırmak için {edit_icon} öğesine tıklayın',
  navigate_content: 'Klasörler/Sayfa Koleksiyonları Arasında Gezinme',
  navigate_content_text:
    'Seçili klasöre/sayfa koleksiyonuna gitmek için {arrow_icon} veya içerik öğesine tıklayın',
  create_new: 'Yeni Oluştur',
  folder: 'Dosya',
  content: 'İçerik',
  create_folder: 'Yeni Klasör',
  update_folder: 'Klasörü Güncelle',
  create_content: 'Yeni İçerik',
  create_collection: 'Koleksiyon Oluştur',
  edit_collection: 'Koleksiyonu Düzenle',
  folder_title: 'Klasör başlığı',
  folder_description: 'Klasör açıklaması',

  file_title: 'Dosya başlığı',
  file_description: 'Dosya açıklaması',
  collection_title: 'Koleksiyon başlığı',
  collection_description: 'Koleksiyon açıklaması',
  content_title: 'İçerik başlığı',
  content_description: 'İçerik açıklaması',
  page_content: 'Sayfa İçeriği',
  page_collection: 'Sayfa Koleksiyonu',
  upload_files: 'Dosya(ları) Yükle',
  create_new_folder: 'Yeni Klasör Oluştur',
  manage_news: 'Haberleri Yönet',
  manage_surveys: 'Anketleri Yönet',
  view_analytics: 'Analitiği Görüntüle',
  administration: 'Yönetim',
  num_file_selected: '{num} Dosya Seçildi',
  sure_delete_tab: 'Sekmeyi silmek istediğinizden emin misiniz?',
  upload_video: 'Video Yükle',
  edit_video: 'Videoyu Düzenle',
  video_list: 'Videolar Listesi',
  video_title_placeholder: 'Video başlığını girin',
  video_duration: 'Video Süresi',
  in_min: '(Dakikalar İçinde)',
  video_duration_placeholder: 'Video süresini girin',
  video_description: 'Video Açıklaması',
  video_description_placeholder: 'Video Açıklamasını Girin',
  submit: 'Göndermek',
  cover: 'Kapak',
  video_title: 'Video Başlığı',
  browser_not_support: 'Tarayıcı videoları desteklemiyor lütfen güncelleyin',
  delete: 'Silmek',
  video_delete_confirmation: 'Videoyu silmek istediğinizden emin misiniz?',
  delete_video: 'Videoyu Sil',
  delete_suggestion: 'Bu videoyu bir daha göremeyeceksiniz',
  delete_content: 'İçeriği Sil',
  delete_content_text: 'Bu içeriği silmek istediğinizden emin misiniz?',
  delete_collection: 'Koleksiyonu Sil',
  delete_collection_text: 'Bu koleksiyonu silmek istediğinizden emin misiniz?',
  delete_file: 'Dosyayı Sil',
  delete_file_text: 'Bu dosyayı silmek istediğinizden emin misiniz?',
  edit_folder: 'Klasörü Düzenle',
};
